import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e5a8660"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "full-screen-image-modal-background" }, null, -1))
const _hoisted_2 = { class: "full-screen-image-modal-loader" }
const _hoisted_3 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ImageZoom = _resolveComponent("ImageZoom")!
  const _directive_trap_focus = _resolveDirective("trap-focus")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _hoisted_1,
    _withDirectives((_openBlock(), _createElementBlock("div", {
      "data-testid-modal": "",
      class: "full-screen-image-modal",
      onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('close')), ["esc"])),
      tabindex: "-1",
      ref: "modal"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Spinner, { size: "bg" })
      ], 512), [
        [_vShow, _ctx.loading]
      ]),
      _createElementVNode("section", {
        "aria-label": _ctx.$t('aria.modal.header')
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "full-screen-image-modal-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ], 8, _hoisted_3),
      _createVNode(_component_ImageZoom, {
        image: _ctx.image,
        onLoaded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = false))
      }, null, 8, ["image"])
    ], 32)), [
      [_directive_trap_focus, true]
    ])
  ]))
}